import { redirect } from "react-router-dom";

export const loaderAuthDashboard = () => {
  // const accessToken = sessionStorage.getItem("accessToken");
  const accessToken = localStorage.getItem("accessTokenUserLanding");
  const isOtherClient =
    localStorage.getItem("isOtherClient") === "true" ? true : false;

  if (!accessToken || !isOtherClient) {
    throw redirect("/");
  }

  return null;
};
